
export default {
    count: [],
    teacherCount:0,
    studentCount:0,
    newEnrollCount:10,
};
